<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="timeOffs"
            sort-by="StartDate"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Time Off Requests"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Time Off Requests</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <report-list-actions
                  :reportOptions="reportOptions"
                  :downloadFilename="reportListFilename"
                ></report-list-actions>
                <v-btn
                  v-if="!isAuditorRole"
                  color="#2b3990"
                  dark
                  class="mb-2"
                  @click="showAdd()"
                >
                  <v-icon left>add</v-icon>
                  Request Time Off
                </v-btn>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewTimeOff(item)">
                mdi-eye
              </v-icon>

              <v-icon v-if="!isAuditorRole" small @click="deleteTimeOff(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn
                color="#2b3990"
                class="white--text"
                @click="getTimeOffRequests()"
                >Reset</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../components/StaffNav";
import ClientSide from "../components/StaffSide";
import Foot from "../components/Footer";
import moment from "moment";
import DateTimeUtil from "../../utils/date-time.util";
import ReportListActions from '../components/Report/ReportListActions.vue'

const url = require("../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
    ReportListActions,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Start Date",
          align: "start",
          value: "StartDate",
        },
        { text: "End Date", value: "EndDate" },
        { text: "Date Requested", value: "dateRequested" },
        { text: "Reason", value: "Reason" },
        { text: "Status", value: "Approved" },
        { text: "Signed By", value: "SignedBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      msg: false,
      search: "",
      text: "",
      timeOffs: [],
      programs: [],
      managers: [],
      staffID: this.$route.params.employeeID,
      isLoading: true,
      staff: localStorage.getItem("Name"),
    };
  },

  created() {
    this.getTimeOffRequests();
    this.getPrograms();
    this.getManagers();
  },

  computed: {
    isAuditorRole() {
      return localStorage.getItem("userRole") === "Auditor";
    },
    selectedEmployee() {
      return this.$store.state.users.allUsers.find(
          (user) => user._id == this.staffID  
      )
    },
    employeeName() {
      return this.selectedEmployee?.Name ?? this.staff
    },
    reportOptions() {
      return { 
        query: {
          name: this.employeeName,
        },
        endpoints: `timeoff/printList/${this.staffID}`,
        dynamic: true
      }
    },
    reportListFilename() {
      return `${this.employeeName} - Time Off Requests`
    }

  },

  methods: {
    initialize() {
      this.timeOffs = [];
    },

    getManagers: function () {
      axios.get(`${url}/users`).then(async (res) => {
        this.managers = res.data.users;
      });
    },

    viewTimeOff(item) {
      this.$router.push({
        path: `/timeOff/${this.staffID}/update-time-off-request/${item._id}`,
      });
    },

    showAdd() {
      this.$router.push({
        path: `/timeOff/${this.staffID}/add-time-off-request`,
      });
    },

    getPrograms: function () {
      axios.get(`${url}/units`).then(async (res) => {
        this.programs = res.data.units;
      });
    },

    deleteTimeOff(item) {
      //const id = item._id;
      confirm("Are you sure you want to delete this time off request?") &&
        this.timeOffDelete(item);
      // console.log(item);
      //return false;
    },

    timeOffDelete(timeOff) {
      let req_body = {
        Url: window.location.href,
        StaffID: timeOff.StaffID,
      };
      axios
        .delete(`${url}/timeOff/${timeOff._id}`, { params: req_body })
        .then((response) => {
          this.getTimeOffRequests();
          if (response.status === 400) {
            response.json().then(function (data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The time off request has been deleted successfully.";
        });
    },

    getTimeOffRequests: function () {
      this.isLoading = true;
      axios
        .get(`${url}/timeOff/staff/requests/${this.staffID}`)
        .then((res) => {
          this.timeOffs = res.data.timeOffs;
          this.timeOffs = this.timeOffs.map((timeOff) => {
            timeOff.dateRequested = moment(timeOff.CreatedDate).format(
              "YYYY-MM-DD"
            );

            timeOff.SignedBy = timeOff.SignedUser
              ? `${timeOff.SignedUser} ${DateTimeUtil.toLocalDateTime(
                  timeOff.SignedDate
                )}`
              : timeOff.SignedBy || "Not yet signed";

            return timeOff;
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
